import {
  CreateMaterializedProcessDocument,
  CreateMaterializedProcessMutation,
  CreateMaterializedProcessMutationVariables,
  ProcessesInputFieldInput,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type InputField = ProcessesInputFieldInput

export enum ResourceType {
  Employee = 'Employee',
}

export const useCreateMaterializeProcess = () => {
  const [materializedProcessMutation, { loading }] = useMutation(
    CreateMaterializedProcessDocument,
    {
      extractorFn: (data: CreateMaterializedProcessMutation) =>
        data.processesMutations.createProcessesMaterializedProcess,
    }
  )

  return {
    loading,
    createMaterializedProcess(variables: CreateMaterializedProcessMutationVariables) {
      return materializedProcessMutation({ variables, awaitRefetchQueries: false })
    },
  }
}
